import styled from 'styled-components'

export const IconAI = styled.div`
  width: 25px;
  display: inline-block;
`
